export const USERS_GET_REQUEST = "@users.get.request";
export const USERS_GET_SUCCESS = "@users.get.success";
export const USERS_GET_FAIL = "@users.get.failure";

export const USER_LOAD_REQUEST = "@user.load.request";
export const USER_LOAD_SUCCESS = "@user.load.success";
export const USER_LOAD_FAIL = "@user.load.failure";

export const USER_CREATE_REQUEST = "@user.create.request";
export const USER_CREATE_SUCCESS = "@user.create.success";
export const USER_CREATE_FAIL = "@user.create.failure";

export const USER_UPDATE_REQUEST = "@user.update.request";
export const USER_UPDATE_SUCCESS = "@user.update.success";
export const USER_UPDATE_FAIL = "@user.update.failure";
